import FormInput from '../../../../../components/Form/FormInput';
import moment from 'moment';
import { usePersonalAfectado } from '../../../../../hooks/usePersonalAfectado';
import { useDocumentoPersAfectado } from '../../../../../hooks/useDocumentoPersAfectado';
import Table, {
  ColumnDefinitionType,
} from '../../../../../components/Table';
import { DocumentoPersAutonomo } from '../../../../../types/DocumentoPersAutonomo';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MyModal from '../../../../../components/Modal';
import { DocumentoPersSubContratado } from '../../../../../types/DocumentoPersSubContratado';
import { Historial } from '../../DocumentosAdjuntos/historial';
import { useDocumento } from '../../../../../hooks/useDocumento';
import {
  downloadAndOpenFile,
  downloadFile,
} from '../../../../../services/Service';
import { Button } from 'react-bootstrap';
import { useUserLogin } from '../../../../../hooks/useUserLogin';
import { useSolicitud } from '../../../../../hooks/useSolicitud';
import ObservacionComponent from '../../../../../components/Observaciones';
import { OBSERVADA_STATUS_ID } from '../../../../../constants/constants';

interface DetailPersonalSubContratadoProps {
  onClose: () => void;
}

const DetailPersonalSubContratado: React.FC<
  DetailPersonalSubContratadoProps
> = ({ onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIdTipoDocumento, setSelectedIdTipoDocumento] =
    useState<number>(0); // Estado para mantener el ID seleccionado
  const toggle = () => setIsOpen(!isOpen);
  const { personalSubContratadoSelected } = usePersonalAfectado();
  const {
    documentoPersonalSubContratadoList,
    handleDocumentoPersSubContratadoSelected,
    documentoPersonalSubContratadoSelected,
  } = useDocumentoPersAfectado();
  const {
    historialDocumentos,
    buscarDocumentosByIdTipoDocumento,
    handleDocumentoSelected,
    documentoInitial,
  } = useDocumento();
  const { isContratistaTipoUsuario } = useUserLogin();
  const { solicitudSelected } = useSolicitud();
  const [
    isOpenModalObservacionDocument,
    setIsOpenModalObservacionDocument,
  ] = useState(false);

  const handleDocumento = async (id: number) => {
    setSelectedIdTipoDocumento(id);
    toggle();
  };
  const getDocumentoSelected = (id: number) => {
    if (id) {
      const doc =
        historialDocumentos.find((d) => d.idTipoDocumento === id) ||
        documentoInitial;
      handleDocumentoSelected(doc);
      toggle();
      setSelectedIdTipoDocumento(0);
    }
  };
  useEffect(() => {
    // Dependiendo de cómo se use historialDocumentos, podrías necesitar un efecto para manejar su actualización
    // Realiza las acciones que necesites con el historialDocumentos actualizado aquí
    //getDocumentoSelected(selectedIdTipoDocumento);
  }, [historialDocumentos]);
  const columns: ColumnDefinitionType<
    DocumentoPersSubContratado,
    keyof DocumentoPersSubContratado
  >[] = [];
  columns.push({
    key: 'tipoDocumento',
    header: 'TIpo Documento',
  });
  columns.push({
    key: 'nombreArchivo',
    header: 'Nombre',
  });
  columns.push({
    key: 'fechaVencimiento',
    header: 'Fecha Vencimiento',
    cell: (data: DocumentoPersSubContratado) => {
      const isExpired =
        data.fechaVencimiento &&
        moment(data.fechaVencimiento).isBefore(moment(), 'day');
      return (
        <span style={{ color: isExpired ? 'red' : 'inherit' }}>
          {data.fechaVencimiento
            ? moment(data.fechaVencimiento).format('DD/MM/YYYY')
            : ''}
        </span>
      );
    },
  });
  columns.push({
    key: 'idUsuarioRevisor',
    header: 'Revisor',
    cell: (data: DocumentoPersSubContratado) => (
      <>
        {data.nombreUsuarioRevisor && data.apellidoUsuarioRevisor
          ? `${data.apellidoUsuarioRevisor},
      ${data.nombreUsuarioRevisor}`
          : ''}
      </>
    ),
  });
  if (
    isContratistaTipoUsuario() &&
    solicitudSelected.idTipoEstado === OBSERVADA_STATUS_ID
  ) {
    columns.push({
      key: 'observacion',
      header: 'Observaciones',
      cell: (data: DocumentoPersSubContratado) => (
        <>
          {data.observacion && (
            <a
              href="#"
              title="Observaciones"
              onClick={() => {
                handleDocumentoPersSubContratadoSelected(data);
                setIsOpenModalObservacionDocument(true);
              }}
            >
              <i
                className="fa fa-search me-2"
                style={{ color: 'red' }}
                aria-hidden="true"
              ></i>
            </a>
          )}
        </>
      ),
    });
  }
  columns.push({
    key: 'id',
    header: 'Acciones',
    cell: (data: DocumentoPersSubContratado) => (
      <>
        <Link
          title="Visualizar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadAndOpenFile(
              'documento-personal-subcontratado/visualizarArchivo',
              data
            );
          }}
          target="_blank"
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        <Link
          title="Descargar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadFile(
              'documento-personal-subcontratado/descargarArchivo',
              data
            );
          }}
          target="_blank"
        >
          <i
            className="fa fa-arrow-down text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>

        <a
          href="#"
          title="Historial de Documentos"
          onClick={() => handleDocumento(data.idTipoDocumento)}
        >
          <i
            className="fa fa-history text-secondary "
            aria-hidden="true"
          ></i>
        </a>
      </>
    ),
  });
  columns.push({
    key: 'statusDocumento',
    header: '',
  });

  return (
    <>
      <MyModal
        isOpen={isOpenModalObservacionDocument}
        toggle={() => setIsOpenModalObservacionDocument(false)}
        title="Observaciones"
        cancelButton={false}
        secondButton={false}
      >
        <ObservacionComponent
          observacion={
            documentoPersonalSubContratadoSelected.observacion
          }
          isEdit={false}
          cancelButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
          returnButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
        ></ObservacionComponent>
      </MyModal>
      <MyModal
        isOpen={isOpen}
        toggle={toggle}
        title="Historial de Documentos"
      >
        <Historial
          tipoDocumentoDisabled={true}
          pathService={`documento-personal-subcontratado/personal-subcontratado/${personalSubContratadoSelected.id}`}
          idTipoDocumentoSelected={selectedIdTipoDocumento}
        />
      </MyModal>
      <span>Personal Autonomo</span>
      <div>
        <div className="row mt-2">
          <FormInput
            id={'tipoDocumento'}
            label={'Tipo Doc Persona'}
            name={'tipoDocumento'}
            value={personalSubContratadoSelected.tipoDocumento || ''}
            isDisabled={true}
          />
          <FormInput
            id={'nroDocumento'}
            label={'Nro. Documento'}
            name={'nroDocumento'}
            value={personalSubContratadoSelected.nroDocumento || ''}
            isDisabled={true}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'nombre'}
            label={'Nombre'}
            name={'nombre'}
            value={personalSubContratadoSelected.nombre || ''}
            isDisabled={true}
          />
          <FormInput
            id={'apellido'}
            label={'Apellido'}
            name={'apellido'}
            value={personalSubContratadoSelected.apellido || ''}
            isDisabled={true}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'fechaIngreso'}
            label={'Fecha Ingreso Trabajo'}
            name={'fechaIngreso'}
            value={
              personalSubContratadoSelected.fechaIngreso
                ? moment(
                    personalSubContratadoSelected.fechaIngreso
                  ).format('DD/MM/YYYY')
                : ''
            }
            isDisabled={true}
          />
          <FormInput
            id={'actividad'}
            label={'Actividad'}
            name={'actividad'}
            value={personalSubContratadoSelected.actividad || ''}
            isDisabled={true}
          />
        </div>
      </div>
      <div className="p-3">
        <div className="row">
          <div className="col-md-12 text-end">
            {/* <Button
                            disabled={true}
                            className="btn-secondary"
                            variant="secondary"
                        > Agregar Documentos
                        </Button> */}
          </div>
        </div>
        <div className="table-responsive ">
          <Table
            data={documentoPersonalSubContratadoList}
            columns={columns}
          ></Table>
        </div>
      </div>
      <div className="col-md-12 d-flex justify-content-center">
        <Button color="btn-info" onClick={onClose} className="mr-2">
          Volver
        </Button>
      </div>
    </>
  );
};

export default DetailPersonalSubContratado;
